import HeroPinned from '../sections/HeroPinned';
import ServicesHorizontal from '../sections/ServicesHorizontal';
import WhyUs from '../sections/WhyUs';
import GalleryReel from '../sections/GalleryReel';
import CtaSection from '../sections/CtaSection';
import GoogleReview from '../components/GoogleReview';
import usePageMeta from '../hooks/usePageMeta';

/**
 * The home page.
 *
 * The order is deliberate and matches the PHP theme: what we do, why us, proof,
 * then the ask.
 */
export default function Home() {
	// Title and description come from Yoast via REST; these are fallbacks only.
	usePageMeta({
		slug: 'home',
		title: 'Tile & Flooring Contractor in Edmonton | Top Tile Construction',
		description:
			'Top Tile Construction installs tile, flooring, drywall, trim, and doors in Edmonton homes, and paints inside and out. Call for a free estimate.',
	});

	return (
		<>
			<HeroPinned />
			<ServicesHorizontal />
			<WhyUs />
			<GalleryReel />
			{/* Social proof directly before the ask: white between the gold reel
			    and the dark closing CTA. */}
			<GoogleReview />
			<CtaSection />
		</>
	);
}
